<template>
  <div class="ele-body">
    <el-card shadow="never">
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="addSurveyQue" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加问卷调查 </el-button>
      </div>
      <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 261px)" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="surveyName" label="名称" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="description" label="描述" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column label="时间范围" show-overflow-tooltip min-width="110">
            <template #default="{ row }">
              <el-tag>{{ row.startTime }}</el-tag> ～
              <el-tag style="margin-left: 0px">{{ row.endTime }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="surveyType" label="问卷类型" show-overflow-tooltip width="80" align="center">
            <template #default="{ row }">
              {{ row.surveyType == 0 ? '公开' : row.surveyType == 1 ? '私有' : '' }}
            </template>
          </el-table-column>
          <el-table-column label="范围" show-overflow-tooltip width="150px" align="center">
            <template #default="{ row }">
              <el-button type="primary" @click="getRangeDetail(row)">查看详情</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="creatorName" label="创建人" width="80px" align="center" />
          <el-table-column prop="state" label="状态" width="75px" align="center">
            <template #default="{ row }">
              <el-switch v-model="row.valid" @change="editState(row)" :active-value="true" :inactive-value="false" />
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" sortable="custom" show-overflow-tooltip width="170" align="center" />
          <el-table-column label="操作" width="150px" align="center" :resizable="false">
            <template #default="{ row }">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">更多操作<i class="el-icon-arrow-down el-icon--right"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <el-link @click="getDetail(row)" icon="el-icon-edit" type="primary" :underline="false">编辑</el-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-link @click="viewForm(row)" icon="el-icon-edit" type="primary" :underline="false">创建表单</el-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-link @click="exportData(row)" icon="el-icon-printer" type="primary" :underline="false">导出报表</el-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-link v-if="row.surveyType == 0" @click="openQrcode(row)" icon="el-icon-edit" type="primary" :underline="false"
                      >获取推广二维码</el-link
                    >
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-popconfirm title="确定要删除此问卷吗？" @onConfirm="removeSurvey(row)" class="ele-action">
                      <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
                    </el-popconfirm>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <el-dialog
      :title="editType == 1 ? '添加问卷调查' : '编辑问卷调查'"
      :visible.sync="showEdit"
      width="50%"
      @closed="resetSurvey"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="110px">
        <el-form-item label="名称:" prop="surveyName">
          <el-input v-model="editForm.surveyName" placeholder="请输入名称" clearable />
        </el-form-item>
        <el-form-item label="描述:" prop="description">
          <el-input type="textarea" :rows="3" v-model="editForm.description" placeholder="请输入描述" clearable />
        </el-form-item>
        <el-form-item label="上传图片：">
          <el-upload
            action="#"
            list-type="picture-card"
            :file-list="fileList"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :http-request="uploadImg"
            :on-success="handleSuccess"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
        <el-form-item label="开始时间:" prop="startTime">
          <el-date-picker
            v-model="editForm.startTime"
            type="datetime"
            placeholder="请选择开始时间"
            value-format="yyyy-MM-dd HH:00:00"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="结束时间:" prop="endTime">
          <el-date-picker
            v-model="editForm.endTime"
            type="datetime"
            placeholder="请选择结束时间"
            value-format="yyyy-MM-dd HH:00:00"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="问卷数量:" prop="num">
          <el-input-number v-model="editForm.num" :min="0" placeholder="请输入问卷数量" />
        </el-form-item>
        <el-form-item label="问卷类型" prop="surveyType">
          <el-radio-group v-model="editForm.surveyType">
            <el-radio :label="0">公开</el-radio>
            <el-radio :label="1">私有</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="editForm.surveyType == 1" label="展示给" required>
          <treeselect
            v-model="belong"
            :options="classTreeData"
            :multiple="true"
            placeholder="请选择部系年级或班级"
            :defaultExpandLevel="3"
            valueConsistsOf="LEAF_PRIORITY"
            :normalizer="
              (d) => {
                return { id: d.id, label: d.name };
              }
            "
            style="line-height: 20px"
          />
        </el-form-item>
        <el-form-item v-if="editForm.surveyType == 1" label="教师">
          <treeselect
            v-model="editForm.teacherId"
            :options="teacherList"
            :required="true"
            :multiple="true"
            placeholder="请选择教师"
            :defaultExpandLevel="2"
            valueConsistsOf="LEAF_PRIORITY"
            :normalizer="
              (d) => {
                return { id: d.id, label: d.name };
              }
            "
            style="line-height: 20px"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>
    <!--表单创建或修改弹窗-->
    <el-dialog title="表单" :visible.sync="showForm" width="60%">
      <el-row :gutter="15">
        <el-col :md="6" style="margin-bottom: 15px">
          <el-card>
            <div style="font-size: 16px; margin-bottom: 10px; font-weight: 500">
              问卷类型
            </div>
            <el-divider />
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                margin-top: 5px;
              "
            >
              <div class="formItems" @click="addItems(1)">普通单选</div>
              <div class="formItems" @click="addItems(2)">普通多选</div>
              <div class="formItems" @click="addItems(0)">输入框</div>
              <div class="formItems" @click="addItems(3)">普通文件</div>
            </div>
          </el-card>
        </el-col>
        <el-col :md="18" style="margin-bottom: 15px">
          <el-card>
            <h2 style="text-align: center">{{ title }}</h2>
            <div style="margin-bottom: 10px">{{ description }}</div>
            <el-divider />
            <div class="form">
              <div v-for="(item, index1) in entryForm" :key="index1" style="margin-top: 10px">
                <!--填空-->
                <div v-if="item.entryType == 0" class="itemform" @mouseover="queIndex = index1" @mouseleave="queIndex = null">
                  <span v-if="item.required == 1" style="color: red">*</span>
                  <span style="font-size: 16px; font-weight: bolder">{{ index1 + 1 }}、{{ item.entryTitle }}：</span>
                  <div style="margin-top: 10px">
                    <el-input style="width: 50%" readonly />
                  </div>
                  <div class="tools">
                    <div style="display: flex; justify-content: flex-end" v-show="queIndex == index1">
                      <el-button type="warning" icon="el-icon-edit" @click="editQue(index1)">编辑</el-button>
                      <el-button type="danger" icon="el-icon-delete" @click="removeItems(index1)">删除</el-button>
                    </div>
                  </div>
                  <div class="editQue" v-if="editQueIndex == index1">
                    <div class="que_triangle"></div>
                    <div style="margin-top: 10px">
                      <el-input style="width: 50%; margin-right: 10px" v-model="item.entryTitle" />
                      <el-checkbox :checked="item.required == 1 ? true : false" @change="(checked) => changeCheck(checked, index1)">必答</el-checkbox>
                    </div>
                    <div style="margin-top: 10px">
                      <el-button type="primary" style="width: 100%" @click="editQueIndex = null">完成编辑</el-button>
                    </div>
                  </div>
                </div>
                <!--单选-->
                <div v-if="item.entryType == 1" class="itemform" @mouseover="queIndex = index1" @mouseleave="queIndex = null">
                  <span v-if="item.required == 1" style="color: red">*</span>
                  <span style="font-size: 16px; font-weight: bolder">{{ index1 + 1 }}、{{ item.entryTitle }}：</span>
                  <div
                    style="
                      margin-top: 10px;
                      display: flex;
                      flex-direction: column;
                    "
                  >
                    <el-radio style="margin-top: 5px" v-for="(radioItem, index) in item.items" :key="index" :label="radioItem.itemValue" />
                  </div>
                  <div class="tools">
                    <div style="display: flex; justify-content: flex-end" v-show="queIndex == index1">
                      <el-button type="warning" icon="el-icon-edit" @click="editQue(index1)">编辑</el-button>
                      <el-button type="danger" icon="el-icon-delete" @click="removeItems(index1)">删除</el-button>
                    </div>
                  </div>
                  <div class="editQue" v-if="editQueIndex == index1">
                    <div class="que_triangle"></div>
                    <div style="margin-top: 10px">
                      <el-input style="width: 50%; margin-right: 10px" v-model="item.entryTitle" />
                      <el-checkbox :checked="item.required == 1 ? true : false" @change="(checked) => changeCheck(checked, index1)">必答</el-checkbox>
                    </div>
                    <div style="margin-top: 10px">
                      <span style="font-size: 15px">选项：</span>
                      <div style="display: flex; flex-direction: column">
                        <div v-for="(radioItem, index2) in item.items" :key="index2" style="display: flex; align-items: center">
                          <div>
                            <el-input style="margin-top: 5px" v-model="radioItem.itemValue" />
                          </div>
                          <i
                            class="el-icon-circle-plus-outline"
                            style="font-size: 25px; margin-left: 10px"
                            @click="addradioItem(item, index1, index2)"
                          ></i>
                          <i class="el-icon-remove-outline" style="font-size: 25px; margin-left: 10px" @click="removeRadioItem(index1, index2)"></i>
                        </div>
                      </div>
                    </div>
                    <div style="margin-top: 10px">
                      <el-button type="primary" style="width: 100%" @click="editQueIndex = null">完成编辑</el-button>
                    </div>
                  </div>
                </div>
                <!--多选-->
                <div v-if="item.entryType == 2" class="itemform" @mouseover="queIndex = index1" @mouseleave="queIndex = null">
                  <span v-if="item.required == 1" style="color: red">*</span>
                  <span style="font-size: 16px; font-weight: bolder">{{ index1 + 1 }}、{{ item.entryTitle }}：</span>
                  <div
                    style="
                      margin-top: 10px;
                      display: flex;
                      flex-direction: column;
                    "
                  >
                    <el-checkbox v-for="(checkItem, index2) in item.items" :key="index2">{{ checkItem.itemValue }}</el-checkbox>
                  </div>
                  <div class="tools">
                    <div style="display: flex; justify-content: flex-end" v-show="queIndex == index1">
                      <el-button type="warning" icon="el-icon-edit" @click="editQue(index1)">编辑</el-button>
                      <el-button type="danger" icon="el-icon-delete" @click="removeItems(index1)">删除</el-button>
                    </div>
                  </div>
                  <div class="editQue" v-if="editQueIndex == index1">
                    <div class="que_triangle"></div>
                    <div style="margin-top: 10px">
                      <el-input style="width: 50%; margin-right: 10px" v-model="item.entryTitle" />
                      <el-checkbox :checked="item.required == 1 ? true : false" @change="(checked) => changeCheck(checked, index1)">必答</el-checkbox>
                    </div>
                    <div style="margin-top: 10px">
                      <span style="font-size: 15px">选项：</span>
                      <div style="display: flex; flex-direction: column">
                        <div v-for="(checkItem, index2) in item.items" :key="index2" style="display: flex; align-items: center">
                          <div>
                            <el-input style="margin-top: 5px" v-model="checkItem.itemValue" />
                          </div>
                          <i
                            class="el-icon-circle-plus-outline"
                            style="font-size: 25px; margin-left: 10px"
                            @click="addradioItem(item, index1, index2)"
                          ></i>
                          <i class="el-icon-remove-outline" style="font-size: 25px; margin-left: 10px" @click="removeRadioItem(index1, index2)"></i>
                        </div>
                      </div>
                    </div>
                    <div style="margin-top: 10px">
                      <el-button type="primary" style="width: 100%" @click="editQueIndex = null">完成编辑</el-button>
                    </div>
                  </div>
                </div>
                <!--文件上传-->
                <div v-if="item.entryType == 3" class="itemform" @mouseover="queIndex = index1" @mouseleave="queIndex = null">
                  <span v-if="item.required == 1" style="color: red">*</span>
                  <span style="font-size: 16px; font-weight: bolder">{{ index1 + 1 }}、{{ item.entryTitle }}：</span>
                  <div style="margin-top: 10px">
                    <el-button size="small" type="primary">点击上传</el-button>
                  </div>
                  <div class="tools">
                    <div style="display: flex; justify-content: flex-end" v-show="queIndex == index1">
                      <el-button type="warning" icon="el-icon-edit" @click="editQue(index1)">编辑</el-button>
                      <el-button type="danger" icon="el-icon-delete" @click="removeItems(index1)">删除</el-button>
                    </div>
                  </div>
                  <div class="editQue" v-if="editQueIndex == index1">
                    <div class="que_triangle"></div>
                    <div style="margin-top: 10px">
                      <el-input style="width: 50%; margin-right: 10px" v-model="item.entryTitle" />
                      <el-checkbox :checked="item.required == 1 ? true : false" @change="(checked) => changeCheck(checked, index1)">必答</el-checkbox>
                    </div>
                    <div style="margin-top: 10px">
                      <el-button type="primary" style="width: 100%" @click="editQueIndex = null">完成编辑</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showForm = false">取 消</el-button>
        <el-button type="primary" @click="submitEntryForm">确 定</el-button>
      </span>
    </el-dialog>
    <!--推广二维码弹窗-->
    <el-dialog title="推广二维码" :visible.sync="showQrCode" width="300px">
      <div style="display: flex; align-items: center; justify-content: center">
        <vue-qr :text="qrCodeText" :size="200" :margin="0" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showQrCode = false">取 消</el-button>
        <el-button type="primary" @click="showQrCode = false">确 定</el-button>
      </span>
    </el-dialog>
    <!--推广展示范围-->
    <el-dialog title="推广范围" :visible.sync="showDetail" width="50%">
      <div style="display: flex; align-items: center">
        <span class="title">教师：</span>
        <el-tag v-for="item in zsTeacherList" :key="item">{{ item }}</el-tag>
      </div>
      <div style="margin-top: 20px; display: flex">
        <span class="title">班级：</span>
        <div>
          <div v-for="item in classList" :key="item" class="classText">
            {{ Object.keys(item)[0] }}：
            {{ item[Object.keys(item)[0]].join('、') }}
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDetail = false">取 消</el-button>
        <el-button type="primary" @click="showDetail = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect'; // 下拉树
  import '@riophae/vue-treeselect/dist/vue-treeselect.css';
  import {
    addSurvey,
    getAllClassTree,
    fetchSurveyForm,
    addEntries,
    changeSurveyStatus,
    getAllDepartTeachers,
    surveyUserDetail,
    surveyExport,
    delSurvey,
    getSurveyDetail,
    updateSurvey,
  } from '@/config/api';
  import VueQr from 'vue-qr';

  export default {
    name: 'StudentRegister',
    components: { Treeselect, VueQr },
    data() {
      return {
        table: {
          // 问卷调查列表
          url: '/survey/listSurvey',
          where: {},
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        choose: [],
        showEdit: false, // 添加问卷调查弹窗
        editForm: {
          surveyName: '',
          surveyType: '1',
          description: '',
          startTime: '',
          endTime: '',
          num: '0',
          teacherId: [],
          imgList: [],
        },
        editRules: {
          // 表单验证规则
          surveyName: [{ required: true, message: '请输入问卷名称', trigger: 'blur' }],
          description: [{ required: true, message: '请输入详细描述', trigger: 'blur' }],
          surveyType: [{ required: true, message: '请选择问卷类型', trigger: 'change' }],
          startTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
          endTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
          num: [{ required: true, message: '请输入问卷数量', trigger: 'blur' }],
        },
        classTreeData: [],
        belong: null,
        showForm: false,
        entryForm: [],
        surveyId: '',
        title: '',
        description: '',
        queIndex: null,
        editQueIndex: null,
        showQrCode: false,
        qrCodeText: '',
        dialogImageUrl: '',
        dialogVisible: false,
        fileList: [], // 文件列表
        fileNameList: [], // 图片在本地的名字集合
        imgList: [], //图片上传到OSS的路径集合
        teacherList: [], //老师列表
        showDetail: false,
        zsTeacherList: [],
        classList: '',
        editType: 1, //1添加 2编辑
        editSurveyId: null,
      };
    },
    created() {
      getAllClassTree().then((res) => {
        if (res.data.resCode == 200) {
          this.classTreeData.push(res.data.data);
        }
      });
    },
    methods: {
      // 预览图片
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      // 上传图片
      async uploadImg(file) {
        try {
          this.fileNameList.push(file.file.name);
          this.$alioss.uploadImg('surveyQue/', file.file).then((res) => {
            // console.log(res)
            if (res.url) {
              this.imgList.push(res.url);
            }
          });
        } catch (err) {
          this.$message.error('上传失败,请稍后再试');
          console.log(err);
        }
      },
      // 文件上传成功钩子
      handleSuccess(res, file, fileList) {
        console.log(res, file, fileList);
        // this.hide = fileList.length >= this.limitCount;
        this.fileList = fileList;
      },
      // 删除图片钩子
      handleRemove(file, fileList) {
        // 获取点击删除图片的索引 并删除在本地的路径和oss路径
        console.log(file, fileList);
        const index = this.fileNameList.indexOf(file.name);
        console.log(index);
        this.fileNameList.splice(index, 1);
        this.fileList.splice(index, 1);
        this.imgList.splice(index, 1);
      },
      // 添加问卷调查
      addSurveyQue() {
        this.editType = 1; //添加
        this.showEdit = true;
        this.editSurveyId = null;
        this.queryDept();
      },
      // 重置问卷调查
      resetSurvey() {
        this.editForm = {
          surveyName: '',
          surveyType: '1',
          description: '',
          startTime: '',
          endTime: '',
          num: '0',
          teacherId: [],
          imgList: [],
        };
        this.imgList = [];
        this.fileList = [];
        this.fileNameList = [];
        this.belong = null;
        this.editSurveyId = null;
      },
      // 查询部门老师列表
      queryDept() {
        getAllDepartTeachers()
          .then((res) => {
            if (res.data.resCode == 200) {
              this.teacherList = this.$util.toTreeData(res.data.data, 'id', 'parentId');
              this.deleteChildren(this.teacherList);
            } else {
              this.$message.error(res.data.resMsg);
            }
          })
          .catch((e) => {
            this.$message.error(e.message);
          });
      },
      // 循环数组 children为空时删除 且部系年级下无children时禁用
      deleteChildren(data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].children) {
            if (data[i].children.length) {
              this.deleteChildren(data[i].children);
            } else {
              if (data[i].type !== 2) {
                delete data[i].children;
                data[i].isDisabled = true;
              }
            }
          }
        }
        return data;
      },

      // 点击获取详情并打开编辑弹窗
      getDetail(row) {
        this.editType = 2; //编辑
        this.showEdit = true;
        this.editSurveyId = row.id;
        this.queryDept();
        let data = {
          id: row.id,
        };
        getSurveyDetail(data).then((res) => {
          if (res.data.resCode == 200) {
            this.editForm = {
              surveyName: res.data.data.survey.surveyName,
              surveyType: JSON.parse(res.data.data.survey.surveyType),
              description: res.data.data.survey.description,
              startTime: res.data.data.survey.startTime,
              endTime: res.data.data.survey.endTime,
              num: res.data.data.survey.num,
              teacherId: res.data.data.teacherId ? res.data.data.teacherId : [],
            };
            this.fileList = res.data.data.survey.imgList
              ? res.data.data.survey.imgList.split(',').map(function(item, index) {
                  return {
                    name: `${index}`,
                    url: item,
                  };
                })
              : [];
            this.fileNameList = res.data.data.survey.imgList
              ? res.data.data.survey.imgList.split(',').map(function(item, index) {
                  return `${index}`;
                })
              : [];
            this.imgList = res.data.data.survey.imgList ? res.data.data.survey.imgList.split(',') : [];
            this.belong = res.data.data.classId ? res.data.data.classId.map((d) => 'c' + d) : [];
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 添加问卷
      save() {
        if (this.editType == 1) {
          if (this.editForm.surveyType == 1) {
            if (!this.belong) return this.$message.error('请选择部系年级或班级！');
            this.editForm.classId = this.belong.map((d) => d.slice(1)).toString();
          }
          this.$refs['editForm'].validate((valid) => {
            if (valid) {
              this.editForm.teacherId = [...new Set(this.editForm.teacherId)]; //js去重
              const loading = this.$loading({ lock: true });
              let formData = new FormData();
              for (let key in this.editForm) {
                if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                  formData.append(key, this.editForm[key]);
                }
              }
              formData.set('imgList', this.imgList.join(','));
              addSurvey(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEdit = false;
                  this.resetSurvey();
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.$refs.table.reload();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            } else {
              return false;
            }
          });
        } else {
          if (this.editForm.surveyType == 1) {
            if (!this.belong) return this.$message.error('请选择部系年级或班级！');
            this.editForm.classId = this.belong.map((d) => d.slice(1)).toString();
          }
          this.$refs['editForm'].validate((valid) => {
            if (valid) {
              this.editForm.teacherId = [...new Set(this.editForm.teacherId)]; //js去重
              const loading = this.$loading({ lock: true });
              let formData = new FormData();
              for (let key in this.editForm) {
                if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                  formData.append(key, this.editForm[key]);
                }
              }
              formData.append('id', this.editSurveyId);
              formData.set('imgList', this.imgList.join(','));
              updateSurvey(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEdit = false;
                  this.resetSurvey();
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.$refs.table.reload();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            } else {
              return false;
            }
          });
        }
      },
      // 开启关闭状态
      editState(row) {
        let data = {
          surveyId: row.id,
          status: row.valid == true ? '1' : '0',
        };
        changeSurveyStatus(data).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: '修改成功' });
            this.$refs.table.reload();
          } else {
            row.valid = !row.valid ? false : true;
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 获取调查问卷详情
      getRangeDetail(row) {
        let id = row.id;
        surveyUserDetail(id).then((res) => {
          if (res.data.resCode == 200) {
            this.showDetail = true;
            this.zsTeacherList = res.data.data.teacher;
            this.classList = res.data.data.student;
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 导出报表
      exportData(row) {
        surveyExport(row.id).then((res) => {
          let blob = new Blob([res.data], {
            type: 'application/octet-stream',
          });
          let objectUrl = URL.createObjectURL(blob);
          // console.log(objectUrl)
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = objectUrl;
          let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
        });
      },
      // 删除调查问卷
      removeSurvey(row) {
        const loading = this.$loading({ lock: true });
        let data = { id: row.id };
        delSurvey(data).then((res) => {
          loading.close();
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: '已删除' });
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 查看表单
      viewForm(row) {
        fetchSurveyForm({ surveyId: row.id }).then((res) => {
          if (res.data.resCode == 200) {
            this.entryForm = res.data.data.list;
            this.showForm = true;
          } else {
            // this.$message.error(res.data.resMsg);
            this.showForm = true;
            this.entryForm = [
              {
                surveyId: row.id, //所属的问卷ID，由上个接口返回
                entryType: 0, //条目类型 0 input 1 single choice 2 multi choice 3 button（附件上传）
                entryTitle: '姓名', //条目标题
                entryOrder: this.entryForm.length + 1, //条目在表单中的顺序
                required: 1, //是否必填
              },
              {
                surveyId: row.id, //所属的问卷ID，由上个接口返回
                entryType: 0, //条目类型 0 input 1 single choice 2 multi choice 3 button（附件上传）
                entryTitle: '手机号', //条目标题
                entryOrder: this.entryForm.length + 1, //条目在表单中的顺序
                required: 1, //是否必填
              },
            ];
          }
          this.title = row.surveyName;
          this.description = row.description;
          this.surveyId = row.id;
        });
        // console.log(row)
      },
      // 添加表单item
      addItems(type) {
        // console.log(type);
        if (type == 0) {
          //填空
          this.entryForm.push({
            surveyId: this.surveyId, //所属的问卷ID，由上个接口返回
            entryType: 0, //条目类型 0 input 1 single choice 2 multi choice 3 button（附件上传）
            entryTitle: '标题', //条目标题
            entryOrder: this.entryForm.length + 1, //条目在表单中的顺序
            required: 1, //是否必填
          });
        }
        if (type == 1) {
          //单选
          this.entryForm.push({
            surveyId: this.surveyId, //所属的问卷ID，由上个接口返回
            entryType: 1, //条目类型 0 input 1 single choice 2 multi choice 3 button（附件上传）
            entryTitle: '标题', //条目标题
            entryOrder: this.entryForm.length + 1, //条目在表单中的顺序
            required: 1, //是否必填
            items: [
              {
                itemOrder: 1,
                itemValue: '选项1',
              },
              {
                itemOrder: 2,
                itemValue: '选项2',
              },
            ],
          });
        }
        if (type == 2) {
          //多选
          this.entryForm.push({
            surveyId: this.surveyId, //所属的问卷ID，由上个接口返回
            entryType: 2, //条目类型 0 input 1 single choice 2 multi choice 3 button（附件上传）
            entryTitle: '标题', //条目标题
            entryOrder: this.entryForm.length + 1, //条目在表单中的顺序
            required: 1, //是否必填
            items: [
              {
                itemOrder: 1,
                itemValue: '选项1',
              },
              {
                itemOrder: 2,
                itemValue: '选项2',
              },
              {
                itemOrder: 3,
                itemValue: '选项3',
              },
            ],
          });
        }
        if (type == 3) {
          //文件
          this.entryForm.push({
            surveyId: this.surveyId, //所属的问卷ID，由上个接口返回
            entryType: 3, //条目类型 0 input 1 single choice 2 multi choice 3 button（附件上传）
            entryTitle: '标题', //条目标题
            entryOrder: this.entryForm.length + 1, //条目在表单中的顺序
            required: 1, //是否必填
          });
        }
      },
      // 删除表单item
      removeItems(index) {
        this.entryForm.splice(index, 1);
      },
      // 编辑表单item
      editQue(index) {
        this.editQueIndex = index;
      },
      // 添加单选选项
      addradioItem(item, index1, index2) {
        this.entryForm[index1].items.splice(index2 + 1, 0, {
          itemOrder: item.items.length + 1,
          itemValue: '选项' + [item.items.length + 1],
        });
      },
      // 删除单选选项
      removeRadioItem(index1, index2) {
        this.entryForm[index1].items.splice(index2, 1);
      },
      // 是否必选
      changeCheck(checked, index1) {
        if (checked) {
          this.entryForm[index1].required = 1;
        } else {
          this.entryForm[index1].required = 0;
        }
      },
      submitEntryForm() {
        console.log(this.entryForm);
        addEntries(this.entryForm, this.surveyId).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: res.data.resMsg });
            this.showForm = false;
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 打开推广二维码
      openQrcode(row) {
        this.qrCodeText = 'http://wx.hdzxy.com/surveyQue/public?surveyId=' + row.id;
        this.showQrCode = true;
      },
    },
  };
</script>

<style scoped>
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }
  .form {
    margin-top: 10px;
  }
  .formItems {
    flex-basis: 40%;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    padding: 0 10px;
    text-align: center;
    border-radius: 30px;
    margin-top: 10px;
  }
  .formItems:hover {
    background-color: #1890ff;
    color: #ffffff;
  }

  .itemform {
    padding: 10px;
    border-top: 1px dashed rgba(236, 236, 236, 0.92);
  }
  .itemform:hover {
    cursor: all-scroll;
    background-color: #f5f5f5;
  }
  .tools {
    margin-top: 10px;
    height: 36px;
  }
  .editQue {
    position: relative;
    background: #fafafa;
    margin: 20px 0 0 0;
    border-top: 1px solid #dfe4e6;
    padding: 10px 10px;
  }
  i:hover {
    cursor: pointer;
    color: #1890ff;
  }
  .title {
    font-weight: 700;
    font-size: 20px;
  }
  .classText {
    font-size: 15px;
    font-weight: 700;
  }
</style>
